import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTheme, styled } from "@mui/material";
import { ShoppingBagIcon } from "../../icons/ShoppingBagIcon.js";
import { ButtonName } from "../../theme/componentNames.js";
import { Button } from "./Button.js";
import { parseThemeUrl } from "../../utils/stringUtils.js";
import { AnimationDot } from "../Animation/AnimationDot.js";
const CartCountContainer = styled("div", { label: "CartCountContainer" })(
  ({ bottomOffset }) => ({
    position: "absolute",
    bottom: +bottomOffset,
    fontWeight: 600,
    lineHeight: 1.4
  })
);
const CustomDtcBagButton = ({
  cartCount,
  handleClick,
  mobile
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  const theme = useTheme();
  const content = mobile ? (_b = (_a = theme.content) == null ? void 0 : _a.cartButton) == null ? void 0 : _b.signedOutMobile : (_d = (_c = theme.content) == null ? void 0 : _c.cartButton) == null ? void 0 : _d.signedOutDesktop;
  const customImage = parseThemeUrl((content == null ? void 0 : content.customIconStartSrc) ?? (content == null ? void 0 : content.customIconEndSrc));
  const enableAnimationDot = mobile ? !!((_f = (_e = theme == null ? void 0 : theme.settings) == null ? void 0 : _e.featureFlags) == null ? void 0 : _f.bagAnimationDotMobile) : !!((_h = (_g = theme == null ? void 0 : theme.settings) == null ? void 0 : _g.featureFlags) == null ? void 0 : _h.bagAnimationDot);
  const enableCartCount = mobile ? !!((_j = (_i = theme == null ? void 0 : theme.settings) == null ? void 0 : _i.featureFlags) == null ? void 0 : _j.cartCountNumberMobile) : !!((_l = (_k = theme == null ? void 0 : theme.settings) == null ? void 0 : _k.featureFlags) == null ? void 0 : _l.cartCountNumber);
  const countNumberYOffset = ((_n = (_m = theme.settings) == null ? void 0 : _m.fonts) == null ? void 0 : _n.numericFontOffsetY) ?? 4;
  const countNumberSize = ((_q = (_p = (_o = theme.componentCSSOverrides) == null ? void 0 : _o[ButtonName.BagButton]) == null ? void 0 : _p[mobile ? "xs" : "md"]) == null ? void 0 : _q.fontSize) ?? 8;
  const bagButtonStyleOverride = (_s = (_r = theme.componentCSSOverrides) == null ? void 0 : _r[ButtonName.BagButton]) == null ? void 0 : _s[mobile ? "xs" : "md"];
  const textButton = !customImage;
  if (textButton) {
    const text = content == null ? void 0 : content.text;
    return /* @__PURE__ */ jsx(
      Button,
      {
        disableResponsiveStyles: true,
        sx: {
          ...bagButtonStyleOverride,
          height: "auto"
        },
        variant: "text",
        color: "default",
        buttonName: ButtonName.BagButton,
        onClick: handleClick,
        children: /* @__PURE__ */ jsx("span", { children: text && cartCount && enableCartCount ? `${text} (${cartCount})` : text })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      variant: "icon",
      color: "default",
      buttonName: ButtonName.BagButton,
      onClick: handleClick,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      sx: bagButtonStyleOverride,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            cursor: "pointer",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            ...bagButtonStyleOverride
          },
          children: [
            cartCount ? /* @__PURE__ */ jsxs(Fragment, { children: [
              enableAnimationDot && /* @__PURE__ */ jsx(
                AnimationDot,
                {
                  className: "bc-animation-dot",
                  size: 8,
                  topOffset: 0,
                  rightOffset: 0,
                  color: "accent",
                  "data-theme-color": "accent"
                }
              ),
              enableCartCount && /* @__PURE__ */ jsx(
                CartCountContainer,
                {
                  className: "bc-cart-count-container",
                  bottomOffset: countNumberYOffset,
                  sx: { fontSize: countNumberSize },
                  children: cartCount
                }
              )
            ] }) : null,
            customImage ? /* @__PURE__ */ jsx(
              "img",
              {
                src: customImage,
                alt: "Bag Icon",
                style: {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  maxWidth: bagButtonStyleOverride == null ? void 0 : bagButtonStyleOverride.width,
                  maxHeight: bagButtonStyleOverride == null ? void 0 : bagButtonStyleOverride.height
                }
              }
            ) : /* @__PURE__ */ jsx(ShoppingBagIcon, {})
          ]
        }
      )
    }
  );
};
export {
  CustomDtcBagButton
};
//# sourceMappingURL=CustomDtcBagButton.js.map
